import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';

export enum AdobeEvent {
  pageLoad = 'pageload',
  click = 'click',
}

interface DataLayerEvent {
  event: AdobeEvent;
  [eventData: string]: any;
}

/**
 * Custom hook to track Adobe events.
 * IMPORTANT: this is different than utils/trackEvent which adds to window.dataLayer
 * whereas this one adds to window.adobeDataLayer
 * @returns a function that takes the event, adds the global object and tracks the event
 */
export const useTrackEvent = () => {
  const loggedIn = useWidgetState(Selectors.isLoggedInSelector) ? '1' : '';
  const guestTierLevel =
    useWidgetState(Selectors.userExtendedTierCodeSelector) || '';
  const crNumber = useWidgetState(Selectors.userAccountIdSelector) || '';

  /* Moving MFA data for every event */
  const optinStatus = useWidgetState(
    Selectors.mfaOptinStatusSelector,
  ) as boolean;
  const tokenValid = useWidgetState(Selectors.mfaTokenValidSelector) as boolean;
  const mfa = {
    optedIn: optinStatus ? '1' : '0',
    verified: tokenValid ? '1' : '0',
  };

  /** member and data are global meaning they will be added to every event */
  const member = {loggedIn, crNumber, guestTierLevel};
  // TODO: When we implement MFA on mobile, 'app' should be 1
  const data = {app: '0'};

  const trackAdobeEvent = (event: DataLayerEvent) => {
    if (window.adobeDataLayer === undefined) {
      window.adobeDataLayer = [];
    }

    if (event) {
      window.adobeDataLayer.push({
        ...event,
        member,
        mfa,
        data,
      });
    }
  };
  return {trackAdobeEvent};
};
